// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"_3vv-T5G0gA3DyiEQSwXggy","header":"_9Mfa8DhB73nYimmCZc8QZ","logout":"_1FGTSZFMRqmsASKY2PXWai","menu":"_2e9VkOz2d9FpWolhGgtscc","active":"_3dlVpkMYV-U6XAIdMmhqL_"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/client-profile/side-bar/ClientProfileSideBar.scss
// module id = 1163
// module chunks = 0